import { connect } from 'react-redux';
import { compose } from 'redux';
import PanelTypography from '../../components/handoff/PanelTypography';
import { getSelectedElement } from '../../selectors/handoff';
import * as handoff from '../../utils/handoff/element';
function mapStateToProps(state) {
    var element = getSelectedElement(state);
    return handoff.getTextStyle(element);
}
export default compose(connect(mapStateToProps))(PanelTypography);
